













import Vue from 'vue'
import PageTitle from '@/components/atoms/PageTitle.vue'
import PointGet from '@/components/molecules/PointGet.vue'

export default Vue.extend({
  name: 'CompleteProfile',
  components: {
    PageTitle,
    PointGet
  },
  methods: {
    onClick() {
      const email = this.$state.registration.forms.email
      const password = this.$state.registration.forms.password
      this.$store.dispatch('auth/login', {
        email: email,
        password: password
      })
    }
  }
})
